import { useTranslation } from 'react-i18next'

export default function LegalDisclaimer() {
  const { t } = useTranslation()
  
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <span className="text-xl flex-shrink-0">⚠️</span>
        <div className="flex-1">
          <p className="text-sm font-medium text-amber-900 mb-1">
            {t('legal.disclaimerTitle')}
          </p>
          <p className="text-xs text-amber-800 leading-relaxed">
            {t('legal.disclaimerText')}
          </p>
          <div className="mt-3 flex flex-wrap gap-3 text-xs">
            <a href="/terms" className="text-amber-700 hover:text-amber-900 underline">
              {t('legal.termsLink')}
            </a>
            <span className="text-amber-400">|</span>
            <a href="/privacy" className="text-amber-700 hover:text-amber-900 underline">
              {t('legal.privacyLink')}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
